import { render } from "./Popover.vue?vue&type=template&id=2d5be879"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"

import "./Popover.vue?vue&type=style&index=0&id=2d5be879&lang=scss"
script.render = render

export default script